module.exports = __webpack_public_path__ + "static/media/icon-background.bd3c487f.png";